import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { useSelector } from "react-redux";

const PaymentMethodInfoDialog = ({
  dialogOpen,
  cashOnly,
  creditOnly,
  onClose,
  yes,
}) => {
  const language = useSelector((state) => state.store.language);
  const message = () => {
    if (cashOnly) {
      return language === "english"
        ? "This product can only be paid using cash - adding this, will remove all other products that don't accept cash payment"
        : "لا يمكن الدفع مقابل هذا المنتج إلا نقدًا - ستؤدي إضافة هذا المنتج إلى إزالة جميع المنتجات الأخرى التي لا تقبل الدفع النقدي";
    } else if (creditOnly) {
      return language === "english"
        ? "This product can only be paid using credit - adding this, will remove all other products that don't accept credit payment"
        : "لا يمكن الدفع مقابل هذا المنتج إلا باستخدام بطاقة الائتمان - ستؤدي إضافة هذا المنتج إلى إزالة جميع المنتجات الأخرى التي لا تقبل الدفع الائتماني";
    }
  };
  return (
    <Dialog
      open={dialogOpen}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{ textAlign: language === "english" ? "left" : "right" }}
      >
        {language === "english" ? "Payment Method" : "طريقة الدفع"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ textAlign: language === "english" ? "left" : "right" }}
        >
          {message()}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: language === "english" ? "flex-end" : "flex-start",
        }}
      >
        <Button onClick={() => yes()} color="primary">
          {language === "english" ? "Yes" : "نعم"}
        </Button>
        <Button onClick={() => onClose()} color="primary">
          {language === "english" ? "No" : "لا"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentMethodInfoDialog;